import { useContext } from 'react';
import { SessionContext, type Role, type SessionState } from './sessionContext';

export function useSession(): SessionState {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession debe usarse dentro de <SessionProvider>.');
  return ctx;
}

/** Roles con segundo factor obligatorio (R1.5). */
export function roleRequiresMfa(role: Role | undefined): boolean {
  return role === 'owner' || role === 'admin' || role === 'operator';
}
